import type { FC } from 'react';

import type { Props } from './AccountNumber';
import { AccountNumber } from './AccountNumber';

export const AccountNo: FC<Props> = ({ account, className }) => {
    return <AccountNumber account={account} className={className} />;
};
